export const mapSubscriptionStatus = {
  active: { label: 'Ativa', class: 'label label-success' },
  canceled: { label: 'Cancelada', class: 'label label-warning' },
  expired: { label: 'Expirada', class: 'label label-error' },
}

export const mapGateway = {
  vindi: { label: 'Vindi', class: 'text-success' },
  iugu: { label: 'Iugu', class: 'text-primary' },
  manual: { label: 'Manual', class: 'text-dark' },
}

export const mapPaymentMethod = {
  credit_card: { label: 'Cartão de crédito', class: 'text-success' },
}

export const mapCollectionStatus = {
  true: { label: 'Ativa', class: 'label label-success' },
  false: { label: 'Inativa', class: 'label label-error' },
}

export const mapBalanceStatus = {
  opened: { label: 'Aberto', class: 'label label-warning' },
  closed: { label: 'Fechado', class: 'label label-primary' },
  paid: { label: 'Pago', class: 'label label-success' },
  paying: { label: 'Pagando', class: 'label label-secondary' },
  error: { label: 'Erro', class: 'label label-error' },
}

export const discountTypes = {
  percent: {
    label: 'Percentual',
    class: 'text-warning',
    filter: ['', '%'],
  },
  fixed: {
    label: 'Valor fixo',
    class: 'text-success',
    filter: ['R$ '],
  },
}

export const collectionTypes = {
  magazine: 'Coleção de revistas',
  book: 'Coleção de livros',
  video: 'Coleção de vídeos',
  course: 'Coleção de cursos',
  mixed: 'Coleção mista',
}

export const filiationRequestStatusClasses = {
  waiting: { label: 'Aguardando', class: 'text-warning' },
  approved: { label: 'Aprovado', class: 'text-success' },
  denied: { label: 'Rejeitado', class: 'text-error' },
}

export const mapLanguage = {
  pt: 'Português',
  en: 'Inglês',
}

export const paymentGateways = {
  iugu: 'Iugu',
  vindi: 'Vindi',
}

export const purchaseStatus = {
  canceled: {
    class: 'label label-rounded label-error',
  },
  success: {
    class: 'label label-rounded label-success',
  },
}
